/**
 * @generated SignedSource<<aab3ed007d5947bba2d159f4466f7955>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DashboardBlockHeroMode = "color" | "image" | "no_fill" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HeroDashboardBlockFragment$data = {
  readonly askAi: boolean;
  readonly color: string | null;
  readonly cover: string | null;
  readonly headerWithMacrosReplaced: string | null;
  readonly heroMode: DashboardBlockHeroMode;
  readonly id: string;
  readonly showWelcomeText: boolean;
  readonly subText: string | null;
  readonly textColor: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardBlockAdminDropdownFragment" | "DashboardBlockItemTemplateFragment">;
  readonly " $fragmentType": "HeroDashboardBlockFragment";
};
export type HeroDashboardBlockFragment$key = {
  readonly " $data"?: HeroDashboardBlockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroDashboardBlockFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroDashboardBlockFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showWelcomeText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "askAi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerWithMacrosReplaced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": "heroMode",
      "args": null,
      "kind": "ScalarField",
      "name": "mode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textColor",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockAdminDropdownFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardBlockItemTemplateFragment"
    }
  ],
  "type": "HeroDashboardBlock",
  "abstractKey": null
};

(node as any).hash = "87702ac2170648b626d378f845973e06";

export default node;
